// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__2tIe_","icon":"style_icon__1ghaf"};